import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { keyTranslator } from "./keyTranslator";

function ZendeskSnippet() {
  const { language } = useParams();
  const [currentLanguage, setCurrentLanguage] = useState(
    language || sessionStorage.getItem("I18N_LANGUAGE")
  );

  useEffect(() => {
    const checkLanguageUpdate = () => {
      const storedLanguage = sessionStorage.getItem("I18N_LANGUAGE");
      setCurrentLanguage(language || storedLanguage);
    };

    const intervalId = setInterval(checkLanguageUpdate, 500);

    return () => clearInterval(intervalId);
  }, [language]);

  const ZENDESK_KEY = keyTranslator(currentLanguage);

  console.log("ZEActiveLang:", currentLanguage);

  useEffect(() => {
    if (ZENDESK_KEY) {
      if (document.getElementById("ze-snippet")) {
        return;
      }

      const script = document.createElement("script");
      script.id = "ze-snippet";
      script.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`;
      script.async = true;
      script.onload = () => {
        console.log("Ze is loaded.");
        window.dispatchEvent(new Event("ZendeskLoaded"));
      };
      script.onerror = () => {
        console.error("Ze snippet not loaded.");
      };
      document.body.appendChild(script);

      return () => {
        const existingScript = document.getElementById("ze-snippet");
        if (existingScript) {
          document.body.removeChild(existingScript);
        }
      };
    }
  }, [ZENDESK_KEY]);

  return null;
}

export default React.memo(ZendeskSnippet);
